import * as z from "zod/v4";

const getAccountBillingSettingsInput_ = z.object({});
export const getAccountBillingSettingsInput: z.ZodType<GetAccountBillingSettingsInput> =
  getAccountBillingSettingsInput_;
export interface GetAccountBillingSettingsInput
  extends z.infer<typeof getAccountBillingSettingsInput_> {}

const getAccountBillingSettingsOutput_ = z.object({
  unifiedBillingEnabled: z.boolean(),
});
export const getAccountBillingSettingsOutput: z.ZodType<GetAccountBillingSettingsOutput> =
  getAccountBillingSettingsOutput_;
export interface GetAccountBillingSettingsOutput
  extends z.infer<typeof getAccountBillingSettingsOutput_> {}

export const getAccountBillingSettings = {
  name: "getAccountBillingSettings" as const,
  input: getAccountBillingSettingsInput,
  output: getAccountBillingSettingsOutput,
};
